import { Add, Edit } from "@carbon/icons-react";
import { useQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { useState } from "react";

import { listTopicsQueryOptions } from "@/api/listTopics";
import { TopicEditDialog } from "@/components/admin/topicEditDialog";
import { Button } from "@/components/input/button";
import { Topic } from "@/schemas/topic";

export const Route = createFileRoute("/dashboard/_authenticated/admin/topics")({
  component: RouteComponent,
  staticData: {
    breadcrumb: ["Topics & questions"],
  },
});

function RouteComponent() {
  const { data: topics, isLoading } = useQuery(listTopicsQueryOptions());
  const [editingTopic, setEditingTopic] = useState<Topic | undefined>();
  const [isCreating, setIsCreating] = useState(false);

  return (
    <div className="flex flex-col gap-6">
      <div className="flex items-center justify-between">
        <h1 className="text-page-title">Topics & questions</h1>
        <Button intent="primary" onClick={() => setIsCreating(true)} size="sm">
          <Add size={16} />
          Add topic
        </Button>
      </div>

      {isLoading ? (
        <div className="text-body2 text-neutral-600">Loading...</div>
      ) : (
        <div className="flex flex-col gap-4">
          {topics?.map((topic) => (
            <div
              className="
                flex flex-col gap-2 rounded-lg border border-primary-200 p-6
              "
              key={topic.id}
            >
              <div className="flex items-start justify-between gap-4">
                <h3 className="text-h3">{topic.category}</h3>
                <Button
                  onClick={() => setEditingTopic(topic)}
                  size="sm"
                  type="button"
                >
                  <Edit size={16} />
                  Edit
                </Button>
              </div>
              <p className="text-body2 text-neutral-600">{topic.description}</p>
            </div>
          ))}
        </div>
      )}

      <TopicEditDialog onOpenChange={setIsCreating} open={isCreating} />
      <TopicEditDialog
        onOpenChange={(open) => {
          if (!open) {
            setEditingTopic(undefined);
          }
        }}
        open={editingTopic !== undefined}
        topic={editingTopic}
      />
    </div>
  );
}
